/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2018 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H133162 on 2/4/2021.
 */

import React from 'react'
import {withRouter} from 'react-router'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {injectIntl, FormattedMessage} from 'react-intl';
import {Button, Card, Grid, Modal, TextArea} from '@scuf/common';
import * as FaultActions from "../FaultActions";
import Loader from '../../common/Loader'
import {userHasActivity} from "../../security/SecurityUtils";
import {ACTIVITY_TYPES} from "../../security/SecurityConst";
import CommentsTable from "../troubleshooting/CommentsTable";
import {verifyAirtimeException} from "../../utils/Helpers";
import {reexportLLPacket} from "../../admin/learningLoop/LearningLoopActions";
import {showNotification} from "../../common/ToastNotification";
import * as SecurityActions from "../../security/SecurityActions";

class CommentsModal extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            comment: '',
            commentsLoading: false,
        }

        this.handleSaveComment = this.handleSaveComment.bind(this)
        this.handleUpdateComment = this.handleUpdateComment.bind(this)
    }

    componentDidMount() {
        this.reloadComments(this.props.fault.faultId)
    }

    reloadComments(id) {
        this.setState({commentsLoading: true})
        return this.props.FaultActions.fetchComments(this.props.fault.assetId, id, userHasActivity(this.props.userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY)).then(() => {
            this.setState({commentsLoading: false})
        }).catch(ex => {
            verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
        })
    }

    handleSaveComment() {
        const external = userHasActivity(this.props.userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY)
        this.props.FaultActions.saveComment(this.props.fault.assetId, this.props.fault.faultId, this.state.comment, external)
            .then(() => {
                this.reloadComments(this.props.fault.faultId).then(() => {
                    this.setState({comment: ''})
                })
            }).then(() => {
            reexportLLPacket(this.props.fault, external)
        }).catch(ex => {
            verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
        });
    }

    handleUpdateComment(id, text, commentSaved) {
        const external = userHasActivity(this.props.userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY)
        this.props.FaultActions.updateComment(this.props.fault.assetId, this.props.fault.faultId, id, text, external)
            .then(() => {
                this.reloadComments(this.props.fault.faultId);
                commentSaved()
            }).then(() => {
            reexportLLPacket(this.props.fault, external)
        }).catch(err => {
            verifyAirtimeException(err.errorKey, this.props.SecurityActions.signOut)
            showNotification({
                translationPropertyKey: 'fault.detail.comment.save.' + err.errorKey,
                severity: "critical",
            })
        });
    }

    render() {
        const {intl, fault} = this.props;

        return (
            <Modal closeIcon={false} onClose={() => this.props.closeModalWindow()} open={this.props.modalWindowOpen}
                   closeOnDimmerClick={true} className="closed-modal">
                <Modal.Header>
                    <FormattedMessage id="fault.detail.title.comments"/>
                </Modal.Header>
                <Modal.Content scrolling={true} className="modal--content">
                    <Grid>
                        <Grid.Row>
                            <Grid.Column className="grid--row" width={12}>
                                <Card className="grid--card">
                                    <Loader loading={this.state.commentsLoading}/>
                                    <Card.Content>
                                        <CommentsTable comments={fault.comments} updateComment={this.handleUpdateComment} currentUserId={this.props.security.userProfile.id}/>
                                        <Grid className="new-comment-panel">
                                            <Grid.Row>
                                                <Grid.Column width={12}>
                                                    <TextArea
                                                        label={intl.formatMessage({id: "fault.detail.label.comment"})}
                                                        value={this.state.comment} onChange={(value) => this.setState({comment: value})}
                                                        helperText={intl.formatMessage({id: "fault.detail.comment.warning"})}
                                                        fluid/>
                                                </Grid.Column>
                                            </Grid.Row>
                                            <Grid.Row>
                                                <Grid.Column width={12}>
                                                    <div className="right">
                                                        <Button content={intl.formatMessage({id: "fault.detail.button.save"})} onClick={this.handleSaveComment} disabled={!this.state.comment}/>
                                                    </div>
                                                </Grid.Column>
                                            </Grid.Row>
                                        </Grid>
                                    </Card.Content>
                                </Card>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Modal.Content>
                <Modal.Footer>
                    <div className="closedModal-buttons">
                        <Button className="mobile-max-width-button"
                                content={intl.formatMessage({id: "fault.detail.action.cancel"})}
                                onClick={() => this.props.closeModalWindow()} size="medium" type="secondary"/>
                    </div>
                </Modal.Footer>
                <Loader loading={this.props.loading}/>
            </Modal>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        fault: state.fault,
        loading: state.fault.fetchCount > 0,
        security: state.security,
        userProfile: state.security.userProfile,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        FaultActions: bindActionCreators(FaultActions, dispatch),
        SecurityActions: bindActionCreators(SecurityActions, dispatch),
    }
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(CommentsModal)))